// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3b2sL","disabled":"FileBtn_disabled__Nitfa","warn":"FileBtn_warn__3uMvv","fade":"FileBtn_fade__1O6wK"};